import React, { useMemo } from 'react';
import { Text } from 'src/@vymo/ui/atoms';
import { NoData, Skelton } from 'src/@vymo/ui/blocks';
import GroupedHistory from 'src/@vymo/ui/components/history/groupedHistory';
import { Keys, locale } from 'src/i18n';
import { getDetails } from 'src/models/details/selectors';
import { getRevyreConfig } from 'src/models/lmsConfig/selectors';
import { useAppSelector } from 'src/store/hooks';
import { TAB_STATUS_KEYS } from '../../constant';
import { getAuditHistory, getStatus } from '../../selector';
import { getTransformedHistories } from './queries';
import styles from '../../index.module.scss';

function AuditHistory(props) {
  const { entityId, workflowType, domainType } = props;
  const serviceType = workflowType || domainType;
  const audits = useAppSelector((state) => getAuditHistory(state, serviceType));
  const profileDetails = useAppSelector(
    (state) => getDetails(state, entityId)?.profiles || [],
  );
  const revyreConfig = useAppSelector(getRevyreConfig);
  const transformedAudits = useMemo(
    () => getTransformedHistories(props, audits, revyreConfig, true),
    [audits, props, revyreConfig],
  );

  const status = useAppSelector((state) =>
    getStatus(state, TAB_STATUS_KEYS.AUDIT_HISTORY),
  );

  return (
    <div className={styles.detailsWrapper__detailsBody__audit}>
      <Text type="h6">{locale(Keys.HISTORY)}</Text>
      {status === 'loading' && <Skelton rounded lines={8} />}
      {status === 'error' && <NoData message={locale(Keys.NO_HISTORY_FOUND)} />}
      {status === 'done' && (
        <GroupedHistory
          histories={transformedAudits}
          {...props}
          profileDetails={profileDetails}
        />
      )}
    </div>
  );
}

export default AuditHistory;
